import { createSelector } from '@ngrx/store';
import { AccountState } from './account.reducer';

export const selectAccountState = (state: { account: AccountState }) => state.account;

export const selectValidationMessage = createSelector(
  selectAccountState,
  (state) => state.passwordValidationMessage
);

export const selectValidationError = createSelector(
  selectAccountState,
  (state) => state.passwordValidationError
);

export const selectDeleteMessage = createSelector(
  selectAccountState,
  (state: AccountState) => state.deleteMessage
);

export const selectDeleteError = createSelector(
  selectAccountState,
  (state: AccountState) => state.deleteError
);
